module.exports = __webpack_public_path__ + "static/media/timeline-2010.29f3217f.webp";